import { FlipRotateState } from "../../types";

export const toggleHorizontal = (state: FlipRotateState) => {
    state.flip.horizontal = !state.flip.horizontal;
};
